var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1308_23787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.3942 63.2049C86.3942 63.2049 47.1207 39.2995 18.341 7.8982L12.6274 13.2345C12.6274 13.2345 56.1894 63.6596 62.4825 85.4221L86.3942 63.2049Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.4339 71.5331L71.4402 77.0939L14.9992 11.011L15.7601 10.305L77.4339 71.5331Z",
    fill: "#C69E3C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.7072 5.62245C14.3513 2.2415 20.0452 2.45485 23.4262 6.09903C26.8071 9.74321 26.5938 15.4371 22.9496 18.818C19.3054 22.199 13.6115 21.9856 10.2306 18.3414C6.84963 14.6973 7.06299 9.00339 10.7072 5.62245Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6526 6.36218C19.6243 7.54861 13.8471 9.1436 8.01145 10.4109L7.93956 10.8186C11.5188 10.6626 18.8941 10.0403 24.5346 7.56277L23.6526 6.36218Z",
    fill: "#EAAE06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2048 62.2582C63.2048 62.2582 39.2994 101.532 7.89806 130.311L13.2344 136.025C13.2344 136.025 63.6595 92.463 85.422 86.1699L63.2048 62.2582Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5344 71.2172L77.0952 77.2109L11.0123 133.652L10.3063 132.891L71.5344 71.2172Z",
    fill: "#C69E3C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.62316 137.943C2.24221 134.299 2.45556 128.605 6.09974 125.224C9.74392 121.843 15.4378 122.057 18.8187 125.701C22.1997 129.345 21.9863 135.039 18.3422 138.42C14.698 141.801 9.0041 141.587 5.62316 137.943Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36302 124.999C7.54945 129.027 9.14444 134.805 10.4117 140.64L10.8195 140.712C10.6635 137.133 10.0412 129.758 7.56361 124.117L6.36302 124.999Z",
    fill: "#EAAE06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2585 85.4463C62.2585 85.4463 101.532 109.352 130.312 140.753L136.025 135.417C136.025 135.417 92.4633 84.9916 86.1702 63.2291L62.2585 85.4463Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2168 77.1181L77.2105 71.5573L133.652 137.64L132.891 138.346L71.2168 77.1181Z",
    fill: "#C69E3C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.944 143.029C134.3 146.41 128.606 146.196 125.225 142.552C121.844 138.908 122.057 133.214 125.701 129.833C129.345 126.452 135.039 126.666 138.42 130.31C141.801 133.954 141.588 139.648 137.944 143.029Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.999 142.289C129.027 141.103 134.804 139.508 140.64 138.24L140.712 137.833C137.133 137.989 129.757 138.611 124.117 141.088L124.999 142.289Z",
    fill: "#EAAE06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4457 86.393C85.4457 86.393 109.351 47.1195 140.752 18.3398L135.416 12.6262C135.416 12.6262 84.991 56.1882 63.2285 62.4813L85.4457 86.393Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1174 77.434L71.5566 71.4403L137.64 14.9993L138.346 15.7603L77.1174 77.434Z",
    fill: "#C69E3C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.028 10.7079C146.409 14.3521 146.195 20.046 142.551 23.4269C138.907 26.8079 133.213 26.5945 129.832 22.9503C126.451 19.3062 126.665 13.6123 130.309 10.2313C133.953 6.85039 139.647 7.06374 143.028 10.7079Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.288 23.652C141.101 19.6238 139.506 13.8466 138.239 8.01088L137.831 7.939C137.987 11.5182 138.609 18.8935 141.087 24.534L142.288 23.652Z",
    fill: "#EAAE06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0795 60.9941C69.4404 54.1648 80.9426 54.5958 87.7719 61.9568C94.6011 69.3177 94.1701 80.8199 86.8092 87.6491C79.4482 94.4784 67.946 94.0474 61.1168 86.6864C54.2876 79.3255 54.7186 67.8233 62.0795 60.9941Z",
    fill: "#AA7D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8892 71.2082C84.6087 75.8714 82.2212 81.0465 77.5581 82.766C72.8949 84.4855 67.7198 82.0981 66.0003 77.4349C64.2808 72.7718 66.6683 67.5967 71.3314 65.8771C75.9945 64.1576 81.1696 66.5451 82.8892 71.2082Z",
    fill: "#E2D04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2283 82.8725C77.6819 78.6977 78.4319 72.7515 79.5061 66.8769L79.1571 66.6537C77.9251 70.0174 75.6627 77.0653 75.7808 83.2252L77.2283 82.8725Z",
    fill: "#AA7D0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1308_23787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.83ea118ebd7563581b7577c7dbd61199.svg";
export { ForwardRef as ReactComponent };